import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import GoogleAnalytics from "./components/GoogleAnalytics";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Privacy from "./pages/Privacy";
import BusinessPlan from "./pages/BusinessPlan";
import NotFound from "./pages/NotFound";
import Cardio from "./pages/projects/Cardio";
import Neuro from "./pages/projects/Neuro";
import Derma from "./pages/projects/Derma";
import Pulmo from "./pages/projects/Pulmo";
import Vision from "./pages/projects/Vision";
import NutriScan from "./pages/projects/NutriScan";
import HealthNet from "./pages/projects/HealthNet";
import ElderBand from "./pages/projects/ElderBand";
import FallCam from "./pages/projects/FallCam";
import HeartPatch from "./pages/projects/HeartPatch";
import SleepBand from "./pages/projects/SleepBand";
import SkinCam from "./pages/projects/SkinCam";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <GoogleAnalytics />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/business-plan" element={<BusinessPlan />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/projects/cardio" element={<Cardio />} />
            <Route path="/projects/neuro" element={<Neuro />} />
            <Route path="/projects/derma" element={<Derma />} />
            <Route path="/projects/pulmo" element={<Pulmo />} />
            <Route path="/projects/vision" element={<Vision />} />
            <Route path="/projects/nutriscan" element={<NutriScan />} />
            <Route path="/projects/healthnet" element={<HealthNet />} />
            <Route path="/projects/elderband" element={<ElderBand />} />
            <Route path="/projects/fallcam" element={<FallCam />} />
            <Route path="/projects/heartpatch" element={<HeartPatch />} />
            <Route path="/projects/sleepband" element={<SleepBand />} />
            <Route path="/projects/skincam" element={<SkinCam />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
